import { useSelector } from 'react-redux';
import useDateString from 'hooks/useDateString';
import { planEndSecSelector } from 'redux/modules/pricing';

export default function usePlanEndDateString(format?: string) {
  const planEndSec = useSelector(planEndSecSelector);
  return useDateString(planEndSec, format);
}
